const config = {
  clientId: process.env.VUE_APP_CLIENT_ID,
  realm: process.env.VUE_APP_REALM,
  url: process.env.VUE_APP_KEYCLOACK_URL
};

const WEP_MOCK_URL = process.env.VUE_APP_WEB_URL;
export { WEP_MOCK_URL };
export const keycloakConfig = config;
